/** Avisos discretos no canto da tela. */
import clsx from 'clsx';
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { createPortal } from 'react-dom';
import { dismissToast, useToastStore, type ToastKind } from '../state/toasts';

const ICONS: Record<ToastKind, typeof Info> = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
};

const TONE: Record<ToastKind, string> = {
  info: 'text-rio-400',
  success: 'text-mata-400',
  warning: 'text-yellow-300',
  error: 'text-red-400',
};

export function Toasts(props: { mobile: boolean }) {
  const toasts = useToastStore((s) => s.toasts);
  // Portal para o <body>: continua clicável (ex.: "Desfazer") mesmo com um
  // diálogo aberto deixando o app (#root) `inert`.
  return createPortal(
    <div
      className={clsx(
        'pointer-events-none fixed z-[90] flex flex-col gap-2',
        props.mobile ? 'top-16 right-14 left-[var(--trilho-fim)] items-stretch' : 'right-16 top-[68px] w-[min(26rem,calc(100vw-2rem))] items-end',
      )}
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map((t) => {
        const Icon = ICONS[t.kind];
        return (
          <div
            key={t.id}
            role={t.kind === 'error' ? 'alert' : 'status'}
            className="glass pointer-events-auto flex w-full items-start gap-2.5 rounded-xl px-3 py-2.5 text-sm text-ink-100 shadow-xl"
          >
            <Icon className={clsx('mt-0.5 size-4 shrink-0', TONE[t.kind])} aria-hidden />
            <p className="min-w-0 flex-1 leading-snug">{t.message}</p>
            {t.action && (
              <button
                type="button"
                className="shrink-0 rounded-md px-1.5 py-0.5 text-xs font-semibold text-mata-300 hover:bg-ink-700 focus-visible:outline-2 focus-visible:outline-mata-400"
                onClick={() => {
                  t.action?.onClick();
                  dismissToast(t.id);
                }}
              >
                {t.action.label}
              </button>
            )}
            <button
              type="button"
              aria-label="Fechar aviso"
              className="shrink-0 rounded-md p-0.5 text-ink-400 hover:bg-ink-700 hover:text-white focus-visible:outline-2 focus-visible:outline-mata-400"
              onClick={() => dismissToast(t.id)}
            >
              <X className="size-4" aria-hidden />
            </button>
          </div>
        );
      })}
    </div>,
    document.body,
  );
}
